import FAQComponent from '../components/FAQ';

const FAQ = () => <FAQComponent />;

export default FAQ;
